<template>
  <div id="tabs" class="cls">
    <!-- <div class="left-nav-switch" @click="handleLeftSwitch">
      <img :src="leftSwitch ? leftSwitchOpen : leftSwitchClose" />
    </div> -->
    <div class="left-box">
      <vue-scroll ref="vs" :ops="ops" @handle-resize="handleResize">
        <div class="tabs-ul">
          <div
            v-for="(item, index) in routeList"
            :id="item.name"
            :key="index"
            class="tabs-li inline"
            :class="activeUrl === item.menuUrl ? 'active' : ''"
            @click="handleChangeCenter(item)"
          >
            <div class="tabs-li-item">
              <img class="icon" :src="iconArray[item.menuName]">
              <span>{{ item.menuName }}</span>
            </div>
          </div>
        </div>
      </vue-scroll>
    </div>
    <div class="right-box" style="padding-right: 32px">
      <Dropdown>
        <a href="javascript:void(0)">
          <div class="right-box-info flex">
            <img class="avatar" src="../../assets/img/avatar.png">
            <p class="name flex">
              <span class="name-text" style="margin-right: 8px">{{
                userInfo.name
              }}</span>
              <span>▼</span>
            </p>
          </div>
        </a>
        <DropdownMenu slot="list">
          <DropdownItem>
            <Button type="primary" @click="changeOperator">切换身份</Button>
          </DropdownItem>
          <DropdownItem>
            <Button type="primary" @click="handleToUserCenter">个人中心</Button>
          </DropdownItem>
          <DropdownItem>
            <Button type="primary" @click="handleLogout">退出登录</Button>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
    <Modal v-model="isShowOperator" title="选择登入单位" footer-hide>
      <div class="identify-content">
        <div
          v-for="(item, index) in adminIdentity"
          :key="item.userId"
          :class="[
            'adminIdentity-box',
            index === +adminIdentityIndex ? 'adminIdentity-active' : ''
          ]"
        >
          <div @click="beforeSwitchIdentify(item, index)">
            {{ item.orgName }}
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { operationList } from './operation';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import cateringAdmin from '@/request/cateringAdmin/index.js';
import loginApi from '@/request/login/index.js';
import vueScroll from 'vuescroll';
import { toBasePlatform } from '@/utils/utils.js';
import { DrawWaterMark } from '@/utils/watermask.js';

export default {
  name: 'TabsList',
  components: {
    vueScroll
  },
  data() {
    return {
      showListLength: 10, // 横向展示的tab
      showColumnList: false, // 是否展示右边的竖向tab
      activeUrl: '',
      tabsListLengthChange: false, // tabList的数量由showListLength个变成showListLength+1个，则为true 否则为false
      iconArray: {
        '工作台': require('@/assets/img/icon/main-icon.png'),
        '课程中心': require('@/assets/img/icon/course-icon.png'),
        '排课中心': require('@/assets/img/icon/courseSchedul-icon1.png'),
        '数据统计': require('@/assets/img/icon/data-icon.png'),
        '订单中心': require('@/assets/img/icon/order-icon.png'),
        '财务中心': require('@/assets/img/icon/finance-icon.png'),
        '教务中心': require('@/assets/img/icon/eduCenter-icon.png'),
        '基础信息中心': require('@/assets/img/icon/basicInfo-icon.png')

      },
      ops: {
        vuescroll: {
          mode: 'native',
          sizeStrategy: 'percent',
          detectResize: true,
          /** 锁定一种滚动方向， 锁定的方向为水平或者垂直方向上滑动距离较大的那个方向 */
          locking: true
        },
        scrollPanel: {
          scrollingX: true,
          scrollingY: false
        },
        rail: {},
        bar: {
          onlyShowBarOnScroll: false,
          background: '#488ffa',
          keepShow: false
        }
      },
      isShowOperator: false,
      rowTabList: operationList,
      leftSwitchOpen: require('@/assets/img/icon_open@2x.png'),
      leftSwitchClose: require('@/assets/img/icon_close@2x.png'),
      newSysAdminDTOList: [],
      waterMask: null
    };
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'theUserIdentity',
      'routeList',
      'adminIdentity',
      'adminIdentityIndex',
      'leftSwitch'
    ])
  },
  watch: {
    $route(to, from) {
      const pathStr = to.path.substring(1);
      const pathArr = pathStr.split('/');
      this.activeUrl = pathArr[0]; // 第一级菜单标识
    },
    routeList(oldVal, newVal) { },
    adminIdentity(oldVal, newVal) { }
  },
  created() {
    this.init();
    console.log('userInfo', this.userInfo.name);
    this.waterMask = new DrawWaterMark(`${this.userInfo.orgName}-${this.userInfo.name}`);
  },
  beforeDestroy() {
    console.log('组件销毁之前--------');
    this.waterMask && this.waterMask.offWatchWatermaskChange();
  },
  methods: {
    ...mapMutations([
      'SET_LEFTNAVLIST',
      'SET_ADMINIDENTITYINDEX',
      'SET_USERINFO',
      'SET_THEUSERIDENTITY',
      'SET_LEFTSWITCH',
      'CLOSE_BROWSINGHISTORYLIST',
      'SET_BROWSINGHISTORYLIST',
      'SET_AUTH_MAP',
      'SET_CACHEROUTE',
      'SET_ADMINIDENTITY'
    ]),
    ...mapActions(['getMenuList']),
    ...mapActions('orderCenter', [
      'udpateSettlementSearchByAction',
      'updateSettlementDetailsSearch'
    ]),
    async init() {
      this.activeUrl = this.$route.path.substring(1).split('/')[0];
      if (this.routeList.length === 0) {
        await this.getMenuList();
      }
      this.initLeftNav();
    },
    // handleLeftSwitch() {
    //   this.SET_LEFTSWITCH(!this.leftSwitch);
    // },
    // 初始化左边菜单
    initLeftNav() {
      const leftNav = this.routeList.filter(item => {
        return item.menuUrl == this.activeUrl;
      });
      try {
        this.handleChangeCenter(leftNav[0]);
      } catch (err) {

      }
    },

    changeOperator() {
      this.isShowOperator = true;
    },
    // 上传token
    async getUrlToken() {
      const res = await cateringAdmin.getUploadtoken();
      if (res.status === 200) {
        this.downloadUrl = res.message.downUrl;
      }
    },
    // 切换中心
    handleChangeCenter(item) {
      console.log('item', item);
      this.activeUrl = item.menuUrl;
      this.SET_LEFTNAVLIST(item.childList);
      if (item.menuUrl === 'basicInfoCenter') {
        localStorage.setItem('basicInfoCenter', 'basicInfoCenter');
      } else {
        localStorage.removeItem('basicInfoCenter');
      }
    },
    // 点击跳转到基础平台个人中心
    handleToUserCenter() {
      this.$Message.info({
        content: '即将前往智慧校园管理平台',
        duration: 1,
        onClose: () => {
          toBasePlatform('applicationAuth2/users/list');
        }
      });
    },
    async getLoginCredential(userId) {
      return new Promise(async(resolve, reject) => {
        const params = {
          userId
        };
        const res = await loginApi.postReloginApi(params);
        if (res.status === 200) {
          this.newSysAdminDTOList = res.message.sysAdminDTOList;
          resolve(res.message.loginCredential);
        }
      });
    },
    async getLoginToken(userId) {
      return new Promise(async(resolve, reject) => {
        const paramsTrue = {
          loginCredential: await this.getLoginCredential(userId),
          userId,
          namespace: 'zhxybasic',
          key: '430-login'
        };
        try {
          const resp = await this.$http.loginTrue(paramsTrue);
          if (resp.status === 200) {
            const extra = JSON.parse(resp.message.extra);
            // const { name, orgId, orgName, id, userType } = extra;
            // this.storeInfo({
            //   userName: name,
            //   orgId: orgId,
            //   id: id,
            //   orgName: orgName,
            //   userType: userType
            // });
            this.storeInfo(extra);
            resolve(resp.message.token);
          } else {
            reject(false);
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    // 保存登录接口返回的信息到 localStorage 和 vuex
    storeInfo(info) {
      localStorage.setItem('userInfo', JSON.stringify(info));
      if (info.id != (localStorage.getItem('oldUserInfo') && JSON.parse(localStorage.getItem('oldUserInfo')) && JSON.parse(localStorage.getItem('oldUserInfo')).id)) {
        localStorage.removeItem('schoolSelectList');
        localStorage.removeItem('courseTableSch');
        localStorage.removeItem('schoolId');
        localStorage.removeItem('schoolName');
        localStorage.removeItem('refundSchoolSelectListOrg');
        localStorage.removeItem('refundSchoolSelectList');
        localStorage.removeItem('settlementSearch'); // 结算账单-主页 搜索条件
        localStorage.removeItem('430cacheSearch');
        this.udpateSettlementSearchByAction(null);
        this.updateSettlementDetailsSearch(null);
        this.CLOSE_BROWSINGHISTORYLIST('');
        this.SET_AUTH_MAP({});
      }

      this.$store.commit('SET_USERINFO', info);
    },
    beforeSwitchIdentify(item, index) {
      if (index === +this.adminIdentityIndex) {
        return false;
      }
      this.$Modal.confirm({
        title: '提示',
        content: `确定切换到 ${item.orgName}`,
        onOk: () => {
          this.handleChangeAdminIdentity(item, index);
        }
      });
    },
    // 切换身份
    async handleChangeAdminIdentity(item, index) {
      // if (item.userIdentity === this.theUserIdentity) {
      //   return false;
      // }

      if (index === +this.adminIdentityIndex) {
        return false;
      }

      let loginToken = '';
      this.$Spin.show();
      try {
        loginToken = await this.getLoginToken(item.userId);
      } catch (err) {
        console.log(err);
      } finally {
        this.$Spin.hide();
      }
      if (!loginToken) {
        return;
      }
      localStorage.setItem('loginToken', loginToken);
      switch (item.userIdentity) {
        case 'admin':
          localStorage.setItem('portOrg', '0');
          this.$store.commit('SET_PORTORG', '0');
          break;
        case 'edu':
          localStorage.setItem('portOrg', '1');
          this.$store.commit('SET_PORTORG', '1');
          break;
        case 'school':
          localStorage.setItem('portOrg', '2');
          this.$store.commit('SET_PORTORG', '2');
          break;
        case 'org':
          localStorage.setItem('portOrg', '3');
          this.$store.commit('SET_PORTORG', '3');
          break;
      }
      // item.name = item.userName
      // this.SET_USERINFO(item);
      this.SET_THEUSERIDENTITY(item.userIdentity);

      await this.$store.dispatch('getAuthcheckPermissionSets', Number(localStorage.getItem('portOrg')));

      const indexNew = this.newSysAdminDTOList.findIndex(x => {
        return x.userId === item.userId;
      });
      // const loginToken = await this.getLoginToken(item.userId);
      // localStorage.setItem('loginToken', loginToken);
      this.SET_ADMINIDENTITY(this.newSysAdminDTOList);
      this.SET_ADMINIDENTITYINDEX(indexNew);

      localStorage.removeItem('schoolSelectList');
      localStorage.removeItem('settlementSearch'); // 结算账单-主页 搜索条件
      localStorage.getItem('areaNameForLeaveListSearch')
        ? localStorage.removeItem('areaNameForLeaveListSearch')
        : '';
      localStorage.getItem('areaCodeForLeaveListSearch')
        ? localStorage.removeItem('areaCodeForLeaveListSearch')
        : '';
      this.udpateSettlementSearchByAction(null);
      this.updateSettlementDetailsSearch(null);

      this.getMenuList();
      this.isShowOperator = false;
      console.log('更新了吗-------34243242342，changeDefaultSchool');
      this.$eventHub.$emit('changeDefaultSchool');
      this.$Message.success({
        content: '切换身份成功，即将前往平台首页',
        duration: 1,
        onClose: () => {
          this.jumpToIndex();
          this.waterMask.updateText(`${this.userInfo.orgName}-${this.userInfo.name}`);
        }
      });
    },
    jumpToIndex() {
      const portOrg = Number(localStorage.getItem('portOrg'));
      let routerName = '';
      this.$eventHub.$emit('refreshDataIndex');
      switch (portOrg) {
        case 0:
          routerName = 'operationIndex';
          break;
        case 1:
          routerName = 'mainCenter_education_educationIndex';
          break;
        case 2:
          routerName = 'schoolIndex';
          break;
        case 3:
          routerName = 'serviceIndex';
          break;
      }
      this.CLOSE_BROWSINGHISTORYLIST('');
      this.$router.push({
        name: routerName
      }, (data) => {
        this.SET_CACHEROUTE([]);
      }, (error) => {
        this.SET_BROWSINGHISTORYLIST(this.$route);
      });
    },
    handleResize(vertical, horizontal, nativeEvent) { },
    handleLogout() {
      this.$store.dispatch('doLogout');
    },
    // 点击更多按钮，切换是否展示右侧的竖向tab
    toggleShowStatus() {
      this.showColumnList = !this.showColumnList;
    }
  }
};
</script>
<style lang="scss" scoped>
#tabs {
  width: 100%;
  padding: 0 21px;
  box-sizing: border-box;
  background: #0958d9;
  display: flex;
  display: -webkit-box !important;
  .left-nav-switch {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 16px;
    img {
      width: 20px;
      height: 18px;
    }
  }
  .left-box {
    width: calc(100% - 180px);
    height: 60px;
    padding-right: 10px;
    box-sizing: border-box;
    position: relative;
    .more-btn {
      position: absolute;
      right: 10px;
      top: 0;
      width: 100px;
      height: 100%;
      background-image: url('../../assets/img/icon_morelabel.png');
      background-size: 22px 16px;
      background-position: center center;
      background-repeat: no-repeat;
      position: 0 0;
      display: inline-block;
    }
    .more-box {
      position: absolute;
      z-index: 1000;
      top: 75px;
      right: -10px;
      display: none;
      padding-top: 16px;
      .more-box-list {
        padding: 10px 30px;
        background: #18142a;
        max-height: 500px;
        overflow-y: scroll;
        border-radius: 5px;
      }
      .more-box-list::-webkit-scrollbar {
        width: 0px;
        background: none;
      }
      .more-box-content {
        display: flex;
        flex-direction: column;
      }
      .tabs-li {
        text-align: center;
      }
      .tabs-li + .tabs-li {
        margin-top: 10px;
      }
    }
    .more-btn:hover {
      .more-box {
        display: inline;
      }
    }
    .more-box::after {
      content: '';
      position: absolute;
      top: 0;
      left: 60%;
      display: inline-block;
      border: 8px solid transparent;
      border-bottom: 8px solid #18142a;
      z-index: 10010;
    }
  }
  .right-box {
    width: 220px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      margin-right: 10px;
    }
    .name {
      cursor: pointer;
      height: 32px;
      line-height: 32px;
      color: #fff;
      font-size: 14px;
      width: 100%;
      .name-text {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block;
        max-width: 180px;
      }
    }
    .right-box-info {
      align-items: center;
    }
  }
  .tabs-ul {
    box-sizing: border-box;
    display: block;
    white-space: nowrap;
    height: 60px;
    display: flex;
    align-items: center;
  }
  .inline {
    cursor: pointer;
    text-align: center;
    line-height: 60px;
  }
  .tabs-li {
    display: inline-block;
    position: relative;
    margin-right: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #fff;
    min-width: 116px;
    height: 100%;
    align-items: center;
    flex-wrap: nowrap;
    a {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
  .tabs-li.active {
    font-weight: 600;
  }
  .tabs-li {
    .tabs-li-item {
      height: 44px;
      line-height: 44px;
      margin-top: 8px;
      display: flex;
      align-items: center;
      justify-content: center;

      .icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }
      &:hover {
        background-color: #003fbb;
        border-radius: 2px;
        height: 44px;
      }
    }
  }
  .tabs-li.active {
    .tabs-li-item {
      background-color: #003fbb;
      border-radius: 2px;
      height: 44px;
    }
  }

  /* .active::after {
    position: absolute;
    bottom: 0;
    left: 0;
    display: block;
    content: '';
    background-color: #fff;
    width: 100%;
    height: 4px;

    font-weight: 600;
  } */
  .tabs-li:hover {
    .del-btn {
      display: inline;
    }
  }
}
.identify-content {
  max-height: 500px;
  overflow-y: auto;
}
.adminIdentity-box {
  height: 50px;
  div {
    cursor: pointer;
  }
}
.adminIdentity-active {
  color: rgb(38, 233, 38);
}
</style>
<style lang="scss">
#tabs .right-box {
  .ivu-dropdown-rel {
    display: flex;
    height: 100%;
  }
}
</style>
